import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box
} from "@mui/material";
import { updateCommunityLink } from "../../api/trainingApi";

const AdminCommunityLinksModal = ({
  open,
  refetchUsers,
  handleClose,
  data,
  updateLinks, // async function: updateLinks({ level, link })
  setSnackbarMessage,
  setSnackbarOpen
}) => {
  const [links, setLinks] = useState({
    level1: "",
    level2: "",
    level3: ""
  });

  // Load existing links into state
  useEffect(() => {
    if (open) {
      setLinks({
        level1: open?.userTypeDetails?.link?.level1 || "",
        level2: open?.userTypeDetails?.link?.level2 || "",
        level3: open?.userTypeDetails?.link?.level3 || ""
      });
    }
  }, [open]);

  const handleInputChange = (level, value) => {
    setLinks((prev) => ({
      ...prev,
      [level]: value
    }));
  };

  const handleSave = async () => {
    try {
      for (const [level, link] of Object.entries(links)) {
        await updateCommunityLink(link, level, open?.userTypeDetails?._id);
      }
      refetchUsers();
      setSnackbarMessage("Community links updated successfully");
      setSnackbarOpen(true);
      handleClose();
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Failed to update community links");
      setSnackbarOpen(true);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
          boxShadow: "0 12px 40px rgba(0,0,0,0.25)"
        }
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          textAlign: "center",
          color: "#333"
        }}
      >
        Update Community Links
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="body2"
          sx={{ mb: 2, color: "#555", textAlign: "center" }}
        >
          Add or update the community links for each training level.
        </Typography>

        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Level 1 Link"
            value={links.level1}
            fullWidth
            size="small"
            placeholder="Enter Level 1 link"
            onChange={(e) => handleInputChange("level1", e.target.value)}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
          />

          <TextField
            label="Level 2 Link"
            value={links.level2}
            fullWidth
            size="small"
            placeholder="Enter Level 2 link"
            onChange={(e) => handleInputChange("level2", e.target.value)}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
          />

          <TextField
            label="Level 3 Link"
            value={links.level3}
            fullWidth
            size="small"
            placeholder="Enter Level 3 link"
            onChange={(e) => handleInputChange("level3", e.target.value)}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2, mt: 1 }}>
        <Button
          variant="outlined"
          size="small"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 3
          }}
          onClick={handleClose}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: "#5daeff",
            textTransform: "none",
            borderRadius: 2,
            px: 3,
            color: "#fff",
            "&:hover": { backgroundColor: "#4b96e1" }
          }}
          onClick={handleSave}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdminCommunityLinksModal;
